import { render, staticRenderFns } from "./zws-steps2.vue?vue&type=template&id=2f94785c&scoped=true"
import script from "./zws-steps2.vue?vue&type=script&lang=js"
export * from "./zws-steps2.vue?vue&type=script&lang=js"
import style0 from "./zws-steps2.vue?vue&type=style&index=0&id=2f94785c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f94785c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f94785c')) {
      api.createRecord('2f94785c', component.options)
    } else {
      api.reload('2f94785c', component.options)
    }
    module.hot.accept("./zws-steps2.vue?vue&type=template&id=2f94785c&scoped=true", function () {
      api.rerender('2f94785c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/zws-steps2.vue"
export default component.exports